import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { adjuntarProgramaSeguridad } from "../../../../redux/actions/obra";
import ProgramaSeguridad from "./ProgramaSeguridad";


const ProgramaSeguridadContainer = ({ obra, open, handleClose }) => {
  const dispatch = useDispatch();
  const [archivosProgramaSeguridad, setArchivosProgramaSeguridad] = useState(null);

  const handleConfirm = () => {
    if (!archivosProgramaSeguridad || Object.keys(archivosProgramaSeguridad).length === 0) {
      toast.error("Adjunte el programa de seguridad");
      return;
    }
    const archivosAsociados = {
      base64: archivosProgramaSeguridad[0].value,
      extension: archivosProgramaSeguridad[0].filename.split(".").pop(),
      nombre: archivosProgramaSeguridad[0].filename.split(".")[0],
    };
    dispatch(adjuntarProgramaSeguridad({
      archivosAsociados: [archivosAsociados],
      idAvisoObra: obra.avisosObra.reduce((a, b) => Math.max(a, b.idAvisoObra), -1),
    })).then(() => {
      toast.success("Se adjunto el programa de seguridad correctamente")
      handleClose();
    });
  }
  return (
    <ProgramaSeguridad

      denominacion={obra.denominacion}
      nroObra={obra.nroObraSRT}
      open={open}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      file={archivosProgramaSeguridad}
      setFile={setArchivosProgramaSeguridad}
    />
  );
}

export default ProgramaSeguridadContainer;